<template lang="html">
    <v-app>
        <div>
            <vue-headful title="슥삭" description="샤이니지 등록" />
            <Navbar></Navbar>
            <v-container fluid>
                <v-layout row wrap>
                    <v-flex xs12 sm2>
                        <Tabbar :ismobile="ismobile" :pagename="pagename" :drawer="drawer" :userinfo="userinfo"></Tabbar>
                    </v-flex>
                    <v-flex :class="isMobile ? 'mx-auto mt-5 xs12': 'mx-auto mt-5 xs12 sm10'">
                        <v-container fluid class="px-5" style="min-height:1200px">
                            <v-row>
                                <span class="col-12 display-1 mt-5 text-left">준비중입니다. 5월 오픈!!</span>
                            </v-row>
                            
                        </v-container>
                        <Footer></Footer>
                    </v-flex>
                </v-layout>
            </v-container>

    
        </div>
    </v-app>
</template>

<script>
import Navbar from '../components/Navbar.vue'
import Tabbar from '../components/Tabbar.vue'
import Footer from '../components/Footer.vue'
import { mapGetters } from 'vuex'
//import Banner from '../components/Banner.vue'

export default {
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize()
        //this.getPopularPoster(0)
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    data() {
        return {
            pagename: 2,
            window: {
                width: 0,
                height: 0
            },
            ismobile: false,

            drawer: false,
            group: null

        }
    },
    computed:{
        ...mapGetters({
            userinfo: 'getUserInfo'
        })
    },
    components: {
        Navbar,
        Tabbar,
        Footer,
        //Banner
    },
    watch: {
        group() {
            this.drawer = false
        }
    },
    methods: {
        handleResize() {
            this.window.width = window.innerWidth;
            if (this.window.width <= 500) {
                this.ismobile = true
            } else {
                this.ismobile = false
            }
            this.window.height = window.innerHeight;
        },
    }
}
</script>

<style lang="css">
</style>


// WEBPACK FOOTER //
// src/pages/SignageReg.vue